import { createSlice } from '@reduxjs/toolkit';
import { get } from 'lodash';

import { initialState } from '../package/constants';

import { createPackageSuccess, updatePackageId } from '../actions/package';
import { prebuildOrderSuccess } from '../actions/order';
import { actualizePackageSuccess } from '../actions/actualization';
import { changePackage } from '../../CheckoutRoutes/PackageCheckout/store/actualize-alternatives/slice';

import { pickUpdatedPackageFields } from '../package/utils';
import type { PackageStateType } from '../package/types';

const name = 'package';

const packageSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    const updatePackageData = (
      state: PackageStateType,
      packageData,
    ): PackageStateType => {
      const updatedPackageData = pickUpdatedPackageFields(packageData);

      return {
        ...state,
        ...updatedPackageData,
        archived_at: null, // При замене архивного пакета другим, в сторе убираем поле archived_at
      };
    };

    builder
      .addCase(prebuildOrderSuccess, (state, { payload }): PackageStateType => {
        const packageData = get(payload, 'data.order.package');
        return updatePackageData(state, packageData);
      })
      .addCase(
        actualizePackageSuccess,
        (state, { payload }): PackageStateType => {
          const packageData = get(payload, 'data.package');
          return updatePackageData(state, packageData);
        },
      )
      .addCase(
        changePackage,
        (state, { payload }): PackageStateType =>
          updatePackageData(state, payload),
      )
      .addCase(
        createPackageSuccess,
        (state, { payload }): PackageStateType =>
          updatePackageData(state, payload),
      )
      .addCase(
        updatePackageId,
        (state, { payload }): PackageStateType => ({
          ...state,
          id: payload,
        }),
      );
  },
});

export default packageSlice.reducer;
